import { useLiveData, useService } from '@toeverything/infra';
import clsx from 'clsx';
import { useCallback } from 'react';

import { ViewService } from '../../services/view';
import { WorkbenchService } from '../../services/workbench';
import {
  ViewSidebarTabBodyTarget,
  ViewSidebarHeaderTarget,
} from '../view-islands';
import * as styles from './sidebar-container.css';

export const SidebarContainer = ({
  className,
  ...props
}: React.HtmlHTMLAttributes<HTMLDivElement>) => {
  const workbenchService = useService(WorkbenchService);
  const workbench = workbenchService.workbench;
  const viewService = useService(ViewService);
  const view = viewService.view;
  const sidebarTabs = useLiveData(view.sidebarTabs$);
  const activeSidebarTab = useLiveData(view.activeSidebarTab$);
  const handleToggleOpen = useCallback(() => {
    workbench.toggleSidebar();
  }, [workbench]);

  return (
    <div
      id="welcome-intro-container"
      className={clsx(styles.sidebarContainerInner, className)}
      {...props}
    >
      <ViewSidebarHeaderTarget viewId={view.id} onToggle={handleToggleOpen} />
      {sidebarTabs.length > 0 ? (
        sidebarTabs.map(sidebar => (
          <ViewSidebarTabBodyTarget
            tabId={sidebar.id}
            key={sidebar.id}
            style={{ display: activeSidebarTab === sidebar ? 'block' : 'none' }}
            viewId={view.id}
            className={clsx(
              styles.sidebarBodyTarget
              // !BUILD_CONFIG.isElectron && styles.borderTop
            )}
            data-testid={`sidebar-tab-content-${sidebar.id}`}
          />
        ))
      ) : (
        <div className={styles.sidebarBodyNoSelection}>No Selection</div>
      )}
    </div>
  );
};
